import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { exportAsCsvFile } from '../shared/function/exportDataToCsv';

@Component({
  selector: 'app-dispatch-device-add',
  templateUrl: './dispatch-device-add.component.html',
  styleUrls: ['./dispatch-device-add.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    MatIcon,
    MatFormField,
    MatLabel,
    MatError,
    MatInput,
    CommonPaginationComponent,
  ],
})
export class DispatchDeviceAddComponent implements OnInit {
  isUploadBoxVisible = true;
  fileUploaded = false;

  fileName: File | null = null;
  addDispatchDeviceForm: FormGroup = this.formBuilder.group({});

  currentPage1 = 1;
  size1 = 10;

  currentPage2 = 1;
  size2 = 10;

  currentPage3 = 1;
  size3 = 10;

  userPermission = [];

  dispatchUploadedDeviceList = [];
  dispatchDuplicateDeviceList = [];
  dispatchInvalidDeviceList = [];

  exportData = [];

  name = 'This is XLSX TO JSON CONVERTER';

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setDispatchDeviceForm();
    this.checkPermission();
    this.isUploadBoxVisible = true;
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'Dispatch Device' &&
          element.create === false
        ) {
          this.navigateBack();
        }
      }
    );
  }

  setDispatchDeviceForm() {
    this.addDispatchDeviceForm = this.formBuilder.group({
      dispatchDetails: new FormControl('', [Validators.required]),
      file: new FormControl('', [Validators.required]),
    });
  }

  downloadMyFile() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute(
      'href',
      '../../assets/downloadableSampleFiles/Sample_Dispatch_Sheet.xlsx'
    );
    link.setAttribute('download', `Sample_Dispatch_Sheet.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  onFileChange(ev) {
    this.spinner.show();
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target as HTMLInputElement;
    if (file.files && file.files.length > 0) {
      const selectedFile = file.files[0];
      this.fileName = selectedFile;
      this.addDispatchDeviceForm.patchValue({
        file: selectedFile.name, // Store file name
      });
      this.addDispatchDeviceForm.controls['dispatchDetails'].setValue('');
      if (
        selectedFile.name.includes('.xlsx') ||
        selectedFile.name.includes('.xls')
      ) {
        reader.onload = () => {
          const data = reader.result;
          workBook = XLSX.read(data, { type: 'binary' });
          jsonData = workBook.SheetNames.reduce((initial, name) => {
            const sheet = workBook.Sheets[name];
            initial = XLSX.utils.sheet_to_json(sheet, {
              raw: false,
              defval: '',
            });
            return initial;
          }, {});
          const dataString = JSON.stringify(jsonData);
          const dataStr = JSON.parse(dataString);
          this.addDispatchDeviceForm.controls['dispatchDetails'].setValue(
            dataStr
          );
        };
        reader.readAsBinaryString(selectedFile);
        this.fileUploaded = true;
        this.spinner.hide();
      }
    } else {
      this.fileName = null;
      // Reset values if no file is selected
      this.addDispatchDeviceForm.patchValue({
        file: '',
      });
    }
    this.spinner.hide();
  }

  saveDeviceDetails() {
    this.dispatchUploadedDeviceList = [];
    this.dispatchDuplicateDeviceList = [];
    this.dispatchInvalidDeviceList = [];

    const payload = this.addDispatchDeviceForm.value;
    delete payload.fileName;
    this.spinner.show();
    this.apiMicroservice.saveDispatchData(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.isUploadBoxVisible = false;

          this.addDispatchDeviceForm.reset();
          this.apiMicroservice.openSnackbar(res.message);
          if (res.duplicateDevices.length > 0) {
            this.dispatchDuplicateDeviceList = res.duplicateDevices;
          }
          if (res.uploadedDevices.length > 0) {
            this.dispatchUploadedDeviceList = res.uploadedDevices;
          }
          if (res.invalidDevices.length > 0) {
            this.dispatchInvalidDeviceList = res.invalidDevices;
          }
          this.apiMicroservice.openSnackbar(res.message);
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.apiMicroservice.openSnackbar(err.error.message);
      },
    });
  }

  onPageChange1(event) {
    this.currentPage1 = event;
  }

  onPageChange2(event) {
    this.currentPage2 = event;
  }

  onPageChange3(event) {
    this.currentPage3 = event;
  }

  onSizeChange1(event) {
    this.currentPage1 = 1;
    this.size1 = event;
  }

  onSizeChange2(event) {
    this.currentPage2 = 1;
    this.size2 = event;
  }

  onSizeChange3(event) {
    this.currentPage3 = 1;
    this.size3 = event;
  }

  exportToExcelDuplicateDispatchedDeviceData(dispatchDuplicateDeviceList) {
    if (confirm('Are you sure?')) {
      this.exportData = dispatchDuplicateDeviceList;
      this.exportData = this.exportData.map(({ ...rest }) => rest);
      exportAsCsvFile(this.exportData, 'DuplicateDispatchedDeviceDetails_');
      this.apiMicroservice.openSnackbar('File Ready For Download.');
    }
  }

  exportToExcelInvalidDispatchedDeviceData(dispatchInvalidDeviceList) {
    if (confirm('Are you sure?')) {
      this.exportData = dispatchInvalidDeviceList;
      this.exportData = this.exportData.map(({ ...rest }) => rest);
      exportAsCsvFile(this.exportData, 'InvalidDispatchedDeviceDetails_');
      this.apiMicroservice.openSnackbar('File Ready For Download.');
    }
  }

  exportToExcelUploadedDispatchedDeviceData(dispatchUploadedDeviceList) {
    if (confirm('Are you sure?')) {
      this.exportData = dispatchUploadedDeviceList;
      this.exportData = this.exportData.map(({ ...rest }) => rest);
      exportAsCsvFile(this.exportData, 'UploadedDispatchedDeviceDetails_');
      this.apiMicroservice.openSnackbar('File Ready For Download.');
    }
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
